import { AccessRequest } from "app/models/access-request.model";
import { CustomerAccessRequestsActions, CustomerAccessRequestsActionTypes  } from "../actions/customer-access-requests.actions";

export interface State {
    accessRequestRequired: boolean;
    accessRequestRequiredLoading: boolean;
    accessRequestLoaded: boolean;
    accessRequestAdded: boolean;
    accessRequestAddLoading: boolean;
    accessRequestAddLoaded: boolean;
    customerAccessRequests: AccessRequest[];
    customerAccessRequestsLoading: boolean;
    customerAccessRequestsLoaded: boolean;
    changeAccessRequestStateLoading: boolean;
    changeAccessRequestStateLoaded: boolean;
}

export const initialState: State = {
    accessRequestRequired: false,
    accessRequestRequiredLoading: false,
    accessRequestLoaded: false,
    accessRequestAdded: false,
    accessRequestAddLoading: false,
    accessRequestAddLoaded: false,
    customerAccessRequests: [],
    customerAccessRequestsLoading: false,
    customerAccessRequestsLoaded: false,
    changeAccessRequestStateLoading: false,
    changeAccessRequestStateLoaded: false
};

export function reducer(state = initialState, action: CustomerAccessRequestsActions): State {
    switch (action.type) {
        case CustomerAccessRequestsActionTypes.AccessRequestRequiredLoad:
            return {
                ...state,
                accessRequestRequiredLoading: true,
                accessRequestLoaded: false
            };
        case CustomerAccessRequestsActionTypes.AccessRequestRequiredLoadSuccess:
            return {
                ...state,
                accessRequestRequired: action.payload,
                accessRequestRequiredLoading: false,
                accessRequestLoaded: true
            };
        case CustomerAccessRequestsActionTypes.AccessRequestRequiredLoadFail:
            return {
                ...state,
                accessRequestRequiredLoading: false,
                accessRequestLoaded: false
            };
        case CustomerAccessRequestsActionTypes.AddAccessRequest:
            return {
                ...state,
                accessRequestAddLoading: true,
                accessRequestAddLoaded: false
            };
        case CustomerAccessRequestsActionTypes.AddAccessRequestSuccess:
            return {
                ...state,
                accessRequestAdded: true,
                accessRequestAddLoading: false,
                accessRequestAddLoaded: true
            };
        case CustomerAccessRequestsActionTypes.AddAccessRequestFail:
            return {
                ...state,
                accessRequestAdded: false,
                accessRequestAddLoading: false,
                accessRequestAddLoaded: false
            };
        case CustomerAccessRequestsActionTypes.CustomerAccessRequestsLoad:
            return {
                ...state,
                customerAccessRequests: [],
                customerAccessRequestsLoading: true,
                customerAccessRequestsLoaded: false
            };
        case CustomerAccessRequestsActionTypes.CustomerAccessRequestsLoadSuccess:
            return {
                ...state,
                customerAccessRequests: action.payload,
                customerAccessRequestsLoading: false,
                customerAccessRequestsLoaded: true
            };
        case CustomerAccessRequestsActionTypes.CustomerAccessRequestsLoadFail:
            return {
                ...state,
                customerAccessRequestsLoading: false,
                customerAccessRequestsLoaded: false
            };
        case CustomerAccessRequestsActionTypes.ChangeAccessRequestState:
            return {
                ...state,
                changeAccessRequestStateLoading: true,
                changeAccessRequestStateLoaded: false
            };
        case CustomerAccessRequestsActionTypes.ChangeAccessRequestStateSuccess:
            const updatedRequest = action.payload;
            const updatedRequests = state.customerAccessRequests.map(ar => 
                ar.id === updatedRequest.id ? updatedRequest : ar
            );
            return {
                ...state,
                customerAccessRequests: updatedRequests,
                changeAccessRequestStateLoaded: true,
                changeAccessRequestStateLoading: false
            };
        case CustomerAccessRequestsActionTypes.ChangeAccessRequestStateFail:
            return {
                ...state,
                changeAccessRequestStateLoading: false,
                changeAccessRequestStateLoaded: false
            };
    }

    return state;
}

export const getAccessRequestRequired = (state: State) => state.accessRequestRequired;
export const getAccessRequestRequiredLoading = (state: State) => state.accessRequestRequiredLoading;
export const getAccessRequestRequiredLoaded = (state: State) => state.accessRequestLoaded;

export const getAccessRequestAdded = (state: State) => state.accessRequestAdded;
export const getAccessRequestAddLoading = (state: State) => state.accessRequestAddLoading;
export const getAccessRequestAddLoaded = (state: State) => state.accessRequestAddLoaded;


export const getCustomerAccessRequests = (state: State) => state.customerAccessRequests;
export const getCustomerAccessRequestsLoading = (state: State) => state.customerAccessRequestsLoading;
export const getCustomerAccessRequestsLoaded = (state: State) => state.customerAccessRequestsLoaded;

export const getChangeAccessRequestStateLoading = (state: State) => state.changeAccessRequestStateLoading;
export const getChangeAccessRequestStateLoaded = (state: State) => state.changeAccessRequestStateLoaded;
